export default {
  "wrapper": "_wrapper_14qch4",
  "qr-code-container": "_qr-code-container_14qch4",
  "qr-code": "_qr-code_14qch4",
  "payment-cta": "_payment-cta_14qch4"
};